import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './chartStyle.css';
import { RootState } from '../../../redux';
import { SketchPicker } from 'react-color';
import SliderWithInput from '../SliderWithInput';
import { FormControl, MenuItem, Popover, Select } from '@mui/material';
import {
  updateCrossTabCellLabelOptions,
  updateCrossTabHeaderLabelOptions,
  updateCrossTabStyleOptions,
} from '../../../redux/ChartPoperties/ChartControlsActions';

const ChartStyle = ({ iconColor }: { iconColor?: string }) => {
  const dispatch = useDispatch();
  const { chartControls, tabTileProps } = useSelector((state: RootState) => ({
    chartControls: state.chartControls,
    tabTileProps: state.tabTileProps,
  }));
  const propKey: string = `${tabTileProps.selectedTabId}.${tabTileProps.selectedTileId}`;

  const [isColorPopoverOpen, setColorPopOverOpen] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [optionName, setOptionName] = useState<string>('Header');

  let options: any = {};
  const labelOptionsList = [
    { name: 'Header', value: true },
    { name: 'Cell', value: false },
  ];

  const menuItemStyle = {
    padding: '2px 10px',
    fontSize: '12px',
  };

  const SelectComponentStyle = {
    fontSize: '12px',
    width: '96%',
    margin: '0 auto 0.5rem auto',
    backgroundColor: 'white',
    height: '1.5rem',
    color: '#404040',
    textAlign: 'start',
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#2bb9bb', // Set focused border color
    },
  };

  options =
    optionName === 'Header'
      ? chartControls.properties[propKey].crossTabHeaderLabelOptions
      : chartControls.properties[propKey].crossTabCellLabelOptions;

  const renderAlignControl = (
    key: 'rowHeaderTextAlign' | 'columnHeaderTextAlign' | 'cellTextAlign',
  ) => {
    const defaultValue = {
      rowHeaderTextAlign: 'left',
      columnHeaderTextAlign: 'center',
      cellTextAlign: 'right',
    };
    return (
      <FormControl fullWidth size="small" style={{ fontSize: '12px', borderRadius: '4px' }}>
        <Select
          value={chartControls.properties[propKey].crossTabStyleOptions[key] || defaultValue[key]}
          variant="outlined"
          onChange={(e) => {
            dispatch(updateCrossTabStyleOptions(propKey, key, e.target.value));
          }}
          sx={SelectComponentStyle}
          MenuProps={{
            PaperProps: {
              sx: {
                '& .MuiMenuItem-root.Mui-selected': {
                  backgroundColor: 'rgba(43, 185, 187, 0.1) !important', // Force background color
                },
                '& .MuiMenuItem-root.Mui-selected:hover': {
                  backgroundColor: 'rgba(43, 185, 187, 0.2) !important', // Change hover state for selected item
                },
              },
            },
          }}
        >
          <MenuItem sx={menuItemStyle} value="left">
            Left
          </MenuItem>
          <MenuItem sx={menuItemStyle} value="center">
            Center
          </MenuItem>
          <MenuItem sx={menuItemStyle} value="right">
            Right
          </MenuItem>
        </Select>
      </FormControl>
    );
  };

  const renderLabels = () => {
    return labelOptionsList.map((item, i) => {
      const isSelected = item.name === optionName;
      return (
        <button
          onClick={() => setOptionName(item.name)}
          className={isSelected ? 'radioButtonSelected' : 'radioButton'}
          key={i}
          style={{
            backgroundColor: isSelected ? 'rgba(224, 224, 224, 1)' : 'white',
            cursor: isSelected ? 'auto' : 'pointer',
          }}
        >
          {item.name}
        </button>
      );
    });
  };

  return (
    <div className="optionsInfo">
      <div className="optionDescription" style={{ marginTop: '10px', color: iconColor }}>
        Border Width
      </div>
      <SliderWithInput
        percent={true}
        sliderValue={chartControls.properties[propKey].crossTabStyleOptions.borderWidth}
        sliderMinMax={{ min: 1, max: 15, step: 1 }}
        changeValue={(value) => dispatch(updateCrossTabStyleOptions(propKey, 'borderWidth', value))}
      />

      {/* <div style={{ paddingBottom: '10px' }}>
        <div className="optionDescription" style={{ marginTop: '5px' }}>
          Line Height
        </div>
        <SliderWithInput
          percent={true}
          sliderValue={chartControls.properties[propKey].crossTabStyleOptions.lineHeight}
          sliderMinMax={{ min: 1, max: 10, step: 0.25 }}
          changeValue={(value) =>
            dispatch(updateCrossTabStyleOptions(propKey, 'lineHeight', value))
          }
        />
      </div> */}

      <div
        style={{
          borderTop: '1px solid rgb(211,211,211)',
          margin: '1rem 1% 1rem',
        }}
      ></div>

      <div className="optionDescription" style={{ marginTop: '0' }}>
        TEXT ALIGNMENT
      </div>

      <div className="optionDescription" style={{ marginTop: '0' }}>
        Row Header Text Alignment
      </div>
      {renderAlignControl('rowHeaderTextAlign')}
      <div className="optionDescription" style={{ marginTop: '0' }}>
        Column Header Text Alignment
      </div>
      {renderAlignControl('columnHeaderTextAlign')}
      <div className="optionDescription" style={{ marginTop: '0' }}>
        Cell label Text Alignment
      </div>
      {renderAlignControl('cellTextAlign')}

      <div
        style={{
          borderTop: '1px solid rgb(211,211,211)',
          margin: '1rem 1% 1rem',
        }}
      ></div>

      <div className="radioButtons" style={{ marginTop: '10px', paddingRight: '0.5px' }}>
        {renderLabels()}
      </div>

      <div
        style={{
          display: 'flex',
          paddingBottom: '8px',
          flexDirection: 'column',
          marginTop: '-10px',
        }}
      >
        <div>
          <div className="optionDescription" style={{ color: iconColor }}>
            Label Color
          </div>
          <div
            style={{
              height: '1.25rem',
              width: '25%',
              backgroundColor: options.labelColor,
              color: options.labelColor,
              border: '2px solid darkgray',
              margin: '0 0 15px 8px',
              cursor: 'pointer',
            }}
            onClick={(e) => {
              setAnchorEl(e.currentTarget);
              setColorPopOverOpen((prev) => !prev);
            }}
          >
            {' c '}
          </div>
        </div>

        <div style={{ transform: 'translateY(-18px)' }}>
          <div className="optionDescription" style={{ color: iconColor }}>
            Font Size
          </div>
          <SliderWithInput
            sliderValue={options.fontSize}
            sliderMinMax={{ min: 8, max: 50, step: 1 }}
            changeValue={(value) => {
              if (optionName === 'Header') {
                dispatch(updateCrossTabHeaderLabelOptions(propKey, 'fontSize', value));
              } else {
                dispatch(updateCrossTabCellLabelOptions(propKey, 'fontSize', value));
              }
            }}
          />

          <div className="optionDescription" style={{ marginTop: '10px', color: iconColor }}>
            Font Weight
          </div>
          <SliderWithInput
            percent={false}
            sliderValue={options.fontWeight}
            sliderMinMax={{ min: 400, max: 900, step: 100 }}
            changeValue={(value) => {
              if (optionName === 'Header') {
                dispatch(updateCrossTabHeaderLabelOptions(propKey, 'fontWeight', value));
              } else {
                dispatch(updateCrossTabCellLabelOptions(propKey, 'fontWeight', value));
              }
            }}
          />
        </div>
      </div>

      <Popover
        open={isColorPopoverOpen}
        onClose={() => setColorPopOverOpen(false)}
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      >
        <SketchPicker
          color={options.labelColor}
          width="16rem"
          onChange={(color) => {
            if (optionName === 'Header') {
              dispatch(updateCrossTabHeaderLabelOptions(propKey, 'labelColor', color.hex));
            } else {
              dispatch(updateCrossTabCellLabelOptions(propKey, 'labelColor', color.hex));
            }
          }}
          disableAlpha
        />
      </Popover>
    </div>
  );
};

export default ChartStyle;
